import styled, { css } from 'styled-components';
import Image from 'next/image';
import { CSS, Transform } from '@dnd-kit/utilities';
import { PhotoButtonEnum } from './types';

export const PhotoCard = styled.div<{
  $isDragging: boolean;
  transform: Transform | null;
  transition?: string;
}>`
  border-radius: 14px;
  justify-self: center;
  position: relative;
  width: 100%;
  height: 105px;
  display: flex;
  aspect-ratio: 1;
  background-size: cover;
  background-position: center;
  user-select: none !important;
  -webkit-touch-callout: none !important;
  transform: ${({ transform }) => CSS.Transform.toString(transform)};

  ${({ $isDragging, transition }) =>
    $isDragging &&
    css`
      transition: ${transition};
      opacity: 0.7;
      z-index: 1;
    `}

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    height: 120px;
  }
`;

const rotateIconStyles = css`
  bottom: 0;
  background-image: url('/static/images/new_ad/icons/icon-rotate.svg');
`;

const photoButtonStyles = {
  [PhotoButtonEnum.Delete]: css`
    top: 0;
    right: 0;
    background-image: url('/static/images/new_ad/icons/icon-delete-photo.svg');
  `,
  [PhotoButtonEnum.RotateLeft]: css`
    right: 0;
    transform: scale(-1, 1);
    ${rotateIconStyles};
  `,
  [PhotoButtonEnum.RotateRight]: css`
    left: 0;
    ${rotateIconStyles};
  `
};

export const PhotoButton = styled.button.attrs<{ iconType: PhotoButtonEnum }>(
  props => ({
    type: 'button'
  })
)`
  position: absolute;
  width: 25px;
  height: 25px;
  background-size: cover;
  background-color: transparent;
  cursor: pointer;
  margin: 5px;
  ${({ iconType }) => photoButtonStyles[iconType]};

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    width: 28px;
    height: 28px;
  }
`;

export const PhotoImage = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: 14px;
  object-fit: cover;
`;
